<!-- @format -->

<template>
	<el-form-item :class="['form-item', item.type === 'placeholder' ? 'form-item-placehodler' : '']" :rules="rules">
		<template #label>
			<template v-if="showLabelIcon && item.options.isKey === '1'">
				<svg-icon name="key" class="form-item-icon" />
			</template>
			<el-tooltip :content="item.options.label" placement="top-start" :show-after="300">
				{{ item.options.label }}
			</el-tooltip>
		</template>
		<div class="form-item-content-field">
			<component :is="getWidgetName(item.type)" v-model="value" :options="item.options" :disabled="isDisabled" />
			<slot name="footer"></slot>
		</div>
	</el-form-item>
</template>

<script setup lang="ts">
	import { getWidgetName } from './Components';
	import type { FormItemRule } from 'element-plus';

	interface Props {
		modelValue: any;
		item: any;
		disabled?: boolean; // 是否只读
		showLabelIcon?: boolean; // 是否展示label-icon
	}

	const props = withDefaults(defineProps<Props>(), {
		disabled: false,
		showLabelIcon: false,
	});

	const emit = defineEmits(['update:modelValue']);

	const isDisabled = computed(() => props.disabled || props.item.options.isRequired === 0);

	const rules = computed((): FormItemRule[] => [
		{ required: props.item.options.isRequired === 2, message: `请输入${props.item.options.label}`, trigger: 'blur' },
	]);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style lang="scss" scoped>
	.form-item {
		padding: 10px;
		margin-bottom: 5px;

		.form-item-icon {
			margin: 0 3px;
		}

		.form-item-content-field {
			gap: 5px;
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;

			:deep(.el-input) {
				width: 100%;

				.el-input__wrapper {
					width: 100%;
				}
			}

			:deep(.el-input-number) {
				width: 100%;
			}
		}

		:deep(.el-form-item__label) {
			display: inline-block;
		}
	}

	.form-item-placehodler {
		:deep(.el-form-item__label) {
			display: none !important;
		}
	}
</style>
